<template lang="html">
  <div class="card">
    <h1 class="card-header">{{title}}</h1>
    <div class="card-total">
      <div class="card-total-left">
        <span v-for="(item, index) of tags" :style="{ background: item !== '公告' ? '#333' : 'red' }" :key="index">{{item.title}}</span>
      </div>
      <div class="card-total-right">
        <span class="icon iconfont">&#xe635;</span>
        <span>{{commentCount}}</span>
        <span class="icon iconfont">&#xe633;</span>
        <span>{{viewCount}}</span>
      </div>
    </div>
    <div class="card-info">
      <img v-lazy="user.avatar" alt="">
      <div class="card-info-details">
        <div class="card-info-details-top">
          <span class="name">{{user.nickName}}</span>
          <!-- <span class="vip">{{vip}}</span> -->
          <span name="time">{{createTime}}</span>
        </div>
        <div class="card-info-details-bottom">
          <span class="hobby">{{user.hobbys ? user.hobbys.join('、') : ''}}</span>
          <div class="">
            <span v-if="isShowEdit(user.username)" class="edit" @click="goCreate">修改</span>
            <span @click="goEdit">回贴</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <span class="icon iconfont">&#xe635;</span> -->
    <div class="rich-text" v-html="content"></div>
    <Loading :loading="false"/>
  </div>
</template>

<script>
import { get } from '../../../utils/request'
import Loading from '../../../components/Loading.vue'
import { get as getUser } from '../../../utils/token'
export default {
  components: {
    Loading
  },
  data () {
    return {
      title: '',
      tags: [
        '公告',
        '置顶',
        '精贴'
      ],
      user: {},
      commentCount: 0,
      viewCount: 0,
      avater: '',
      nickName: '',
      vip: '',
      createTime: '',
      content: '',
      loading: false
    }
  },
  mounted () {
    this.getDetails()
  },
  methods: {
    goCreate () {
      const id = this.$route.params.id
      this.$router.push(`/exerland/create?id=${id}`)
    },
    goEdit () {
      const el = document.getElementById('rich')
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
    },
    isShowEdit (username) {
      const user = getUser('user')
      return Object.is(username, user.username)
    },
    getDetails () {
      this.loading = true
      const promise = get({
        url: `/bbs/articleDetail/${this.$route.params.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          Object.assign(this, detail)
          // console.log('getDetails', detail)
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/font/iconfont.css';
.card {
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 2px;
  background-color: #fff;
  box-shadow: 0 1px 2px 0 rgba(0,0,0,.05);
  .card-header {
    font-size: 24px;
    line-height: 36px;
  }
  .card-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0 15px;
    .card-total-left {
      span {
        background-color: #FF5722;
        color: #fff;
        height: 20px;
        line-height: 20px;
        border-radius: 2px;
        display: inline-block;
        margin-right: 5px;
        padding: 0 6px;
        font-size: 12px;
      }
    }
    .card-total-right {
      display: inline-block;
      text-align: right;
      height: 16px;
      box-sizing: border-box;
      span {
        color: #333;
        font-size: 13px;
        padding-left: 4px;
        line-height: 13px;
        display: inline-block;
      }
      .icon {
        font-size: 16px;
        margin-left: 10px;
      }
    }
  }
  .card-info {
    line-height: 20px;
    padding: 15px 15px 15px 15px;
    font-size: 13px;
    background-color: #f8f8f8;
    color: #999;
    display: flex;
    img {
      width: 48px;
      height: 48px;
      margin-right: 15px;
    }
    .card-info-details {
      width: 100%;
      display: inline-block;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      .card-info-details-top {
        span {
          display: inline-block;
          margin-right: 10px;
        }
        .name {
          color: #01AAED;
        }
        .vip {
          height: 16px;
          line-height: 16px;
          padding: 0 3px;
          background-color: #FF5722;
          color: #fff;
          border-radius: 2px;
        }
        .time {
          line-height: 20px;
          padding: 15px 15px 15px 75px;
          font-size: 13px;
          background-color: #f8f8f8;
          color: #999;
        }
      }
      .card-info-details-bottom {
        display: flex;
        justify-content: space-between;
        span {
          display: inline-block;
          color: #fff;
          background: #009688;
          padding: 0 10px;
          cursor: pointer;
        }
        .hobby {
          max-width: calc(100% - 46px);
          white-space: nowrap;
          background: #f8f8f8;
          display: block;
          color: #333;
          padding-left: 0;
          display: inline-block;
        }
        .edit {
          margin-right: 10px;
        }
      }
    }
  }
  .rich-text {
    margin: 20px 0;
    img {
      max-width: 100% !important;
      cursor: crosshair;
    }
  }
}
</style>
